import { useEffect, useState } from "react";
import { ExternalLink, MapPin, FileText, Building2, Radio, Cloud, Smartphone, Globe, Megaphone, Search } from "lucide-react";
import { useLang } from "../i18n";
import api from "../api";
import Reveal from "../components/Reveal";
import Marquee from "../components/Marquee";

const SERVICES = [
  { icon: Radio, key: "ei_svc_tlc" },
  { icon: Cloud, key: "ei_svc_cloud" },
  { icon: Smartphone, key: "ei_svc_app" },
  { icon: Globe, key: "ei_svc_web" },
  { icon: Megaphone, key: "ei_svc_brand" },
  { icon: Search, key: "ei_svc_seo" },
];

const Sponsor = () => {
  const { t } = useLang();
  const [co, setCo] = useState(null);
  useEffect(() => {
    api.get("/company").then(({ data }) => setCo(data)).catch(() => {});
  }, []);
  const name = co?.name || "EI SRL";
  const country = co?.country || "Italia";
  const vat = co?.vat || "16017671005";
  const web = co?.web || "enterimprese.it";
  return (
    <main className="pt-16" data-testid="sponsor-page">
      <section className="max-w-5xl mx-auto px-5 sm:px-8 pt-20 pb-24">
        <Reveal className="text-center mb-14">
          <p className="font-mono2 text-xs tracking-[0.35em] uppercase text-gold mb-6">{t("ei_kicker")}</p>
          <div className="inline-block bg-white rounded-2xl px-10 py-8 mb-8 glow-orange" data-testid="ei-logo-card">
            <img src="/img/ei-logo.png" alt="EI SRL — Enterimprese" className="h-24 sm:h-28 w-auto" />
          </div>
          <h1 className="font-display font-extrabold text-3xl sm:text-5xl tracking-tight leading-tight mb-4" data-testid="ei-title">
            EI SRL · Enterimprese
          </h1>
          <p className="font-serif-it text-xl sm:text-2xl text-gold">{t("ei_tagline")}</p>
        </Reveal>

        <Reveal>
          <div className="rounded-2xl border border-white/10 bg-card p-8 sm:p-10 mb-10">
            <p className="text-mist leading-relaxed text-sm sm:text-base mb-5" data-testid="ei-desc-1">{t("ei_p1")}</p>
            <p className="text-mist leading-relaxed text-sm sm:text-base" data-testid="ei-desc-2">{t("ei_p2")}</p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-10" data-testid="ei-services">
            {SERVICES.map(({ icon: Icon, key }, i) => (
              <div key={key} className="rounded-xl border border-white/10 bg-card p-5 text-center hover:border-ember/50 transition-colors">
                <Icon className="w-5 h-5 mx-auto text-ember mb-2.5" />
                <p className="font-mono2 text-[10px] tracking-[0.15em] uppercase text-mist leading-snug">{t(key)}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="rounded-2xl border border-gold/30 bg-gold/5 p-8" data-testid="ei-legal">
            <div className="grid sm:grid-cols-3 gap-6 text-center sm:text-left">
              <div>
                <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold mb-2 flex items-center justify-center sm:justify-start gap-1.5"><MapPin className="w-3.5 h-3.5" /> {t("ei_hq")}</p>
                <p className="text-sm text-white/90">{name}<br />{country}</p>
              </div>
              <div>
                <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold mb-2 flex items-center justify-center sm:justify-start gap-1.5"><FileText className="w-3.5 h-3.5" /> {t("ei_vat")}</p>
                <p className="text-sm text-white/90">P.IVA {vat}</p>
              </div>
              <div>
                <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold mb-2 flex items-center justify-center sm:justify-start gap-1.5"><Building2 className="w-3.5 h-3.5" /> {t("ei_web")}</p>
                <a href={`https://${web}`} target="_blank" rel="noopener noreferrer" data-testid="ei-site-link"
                  className="inline-flex items-center gap-1.5 text-sm text-ember hover:text-gold transition-colors">
                  {web} <ExternalLink className="w-3.5 h-3.5" />
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
      <Marquee text={t("marquee")} />
    </main>
  );
};

export default Sponsor;
